<template>
  <div class="ordinaryModify">
    <el-dialog
      :popper-append-to-body="false"
      center
      :title="'钻石现货列表' + '(' + modifyingReplication.styleNumber + ')'"
      :close-on-click-modal="false"
      :visible.sync="diamondSpotDialogVisible"
      :before-close="handleClose"
    >
      <el-table
        :data="gridData"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        class="tableData"
        style="width: 100%"
      >
        <el-table-column property="" label="参数信息" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.gender">{{ scope.row.gender }}戒</span>
          </template>
        </el-table-column>
        <el-table-column property="texture" label="材质" width="100"></el-table-column>
        <el-table-column property="mainStoneName" label="主石名称" width="80"></el-table-column>
        <el-table-column property="mainStoneNumber" label="主石数量" width="80"></el-table-column>
        <el-table-column property="mainStone" label="主石重量" width="80"></el-table-column>
        <el-table-column property="assistStoneNameOne" label="辅石1名称" width="80"></el-table-column>
        <el-table-column property="assistStoneNumberOne" label="辅石1数量" width="80"></el-table-column>
        <el-table-column property="assistStoneWeightOne" label="辅石1重量" width="80"></el-table-column>
        <el-table-column property="assistStoneNameTwo" label="辅石2名称" width="80"></el-table-column>
        <el-table-column property="assistStoneNumberTwo" label="辅石2数量" width="80"></el-table-column>
        <el-table-column property="assistStoneWeightTwo" label="辅石2重量" width="80"></el-table-column>
        <el-table-column property="totalWeight" label="总重量" width="60"></el-table-column>
        <el-table-column property="mainStoneClarity" label="净度" width="60"></el-table-column>
        <el-table-column property="mainStoneColour" label="色度" width="60"></el-table-column>
        <el-table-column property="" label="GIA" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.gia | cutFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column property="ringSize" label="规格" width="70"></el-table-column>
        <el-table-column property="seriesName" label="系列" width="70"></el-table-column>
        <el-table-column
          property="settlementAmount"
          v-if="!hasPermission('展厅') || !hasPermission('加盟公司总经理') || !hasPermission('业务-数据查询')"
          label="结算金额"
          width="100"
        ></el-table-column>
        <el-table-column property="labelPrice" label="标签价格" width="100"></el-table-column>
      </el-table>
      <div class="pageClass">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="listQuery.current"
          :page-size="listQuery.size"
          @current-change="cartSpotListCurrentPage($event)"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getSpot } from '@/api/orderApi';
import { cutFilter } from '@/utils/filetrs';
export default {
  props: {
    diamondSpotDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      listQuery: {
        id: '',
        current: 1,
        size: 5,
        styleNumber: this.modifyingReplication.styleNumber,
      },
      total: 0,
      gridData: [],
    };
  },
  filters: {
    cutFilter,
  },
  mounted() {
    this.getSpotList();
  },
  methods: {
    // 获取列表数据
    getSpotList() {
      this.listQuery.id = this.modifyingReplication.id;
      getSpot(this.listQuery).then((res) => {
        this.gridData = [];
        res.data.records.forEach((item) => {
          this.gridData.push(item);
        });
        this.total = res.data.total;
      });
    },
    // 分页
    cartSpotListCurrentPage(ev) {
      this.listQuery.current = ev;
      this.getSpotList();
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('onCloseSelectDialog');
    },
  },
};
</script>

<style scoped lang="scss">
.ordinaryModify {
  /deep/ .el-dialog {
    width: 1500px;
  }

  /deep/ .el-dialog--center .el-dialog__body {
    padding: 0 10px 10px 10px;
  }

  /deep/ .el-table .cell {
    padding: 0;
  }

  .el-button {
    width: 100%;
  }

  .el-button--text {
    color: red;
  }

  .pageClass {
    text-align: center;
    padding: 20px 0;
    background: #fff;
  }

  /deep/ .el-pager li.active + li {
    border-left: none;
  }
}
</style>
